const crudConfig = {
    endpoint: 'criteriapredicatepartrels',
    primaryKey: 'partId',
    functions: {},
    metadata: {
        endpoint: 'cds/criteriapredicatepartrels',
        functions: {
            fetch: {
                method: 'get',
                returnType: 'Object',
                service: 'cds',
                args: [],
                query: {}
            }
        }
    }
};
export default crudConfig;
